import { Block, Spec, str, fmtDateTime } from "./SubmissionBlocks";

/**
 * Newsletter subscriber detail. Four fields is all the row carries.
 *
 * Unsubscribing is deliberately not offered, matching the website studio's
 * stance: this table records who asked to hear from us, and removing someone
 * is a mailing-list operation that belongs where the sending happens.
 */
export function SubscriberDetail({ payload: p }: { payload: Record<string, unknown> }) {
  return (
    <div className="space-y-4">
      <Block title="Subscriber">
        <Spec label="Name" value={str(p.name)} />
        <Spec
          label="Email"
          value={
            str(p.email) ? (
              <a className="text-primary-text hover:underline" href={`mailto:${p.email}`}>
                {String(p.email)}
              </a>
            ) : null
          }
        />
        <Spec label="Subscribed" value={fmtDateTime(p.subscribedAt)} />
        <Spec label="Website ID" value={str(p.id)} mono />
      </Block>

      <p className="text-xs leading-relaxed text-muted-foreground">
        Unsubscribing is not offered here. This list records who asked to hear from us; removing
        someone is a mailing-list operation and belongs wherever the sending happens.
      </p>
    </div>
  );
}
